import Banner04 from "../assets/images/NewBannerSizer.png";
import Banner05 from "../assets/images/NewBannerSizesfd.png";
import Banner06 from "../assets/images/NewBannerSize.png";

export const APPLICATION_NAME = "YGIIBUSINESS";
export const APPLICATION_NAME_NORMAL = "Ygii - Business";
export const APP_VERSION = "2.0.0";

export const LOCAL_STORAGE_ACCESS_TOKEN = `${APPLICATION_NAME}_ACCESS_TOKEN`;
export const LOCAL_STORAGE_REFRESH_TOKEN = `${APPLICATION_NAME}_REFRESH_TOKEN`;
export const LOCAL_STORAGE_RECIPIENT_ACCESS_TOKEN =
  "YGII_RECIPIENT_ACCESS_TOKEN";
export const LOCAL_STORAGE_RECIPIENT_REFRESH_TOKEN =
  "YGII_RECIPIENT_REFRESH_TOKEN";

export const LOCAL_STORAGE_PHONE_COUNTRY = `${APPLICATION_NAME}_PHONE_COUNTRY`;
export const LOCAL_STORAGE_SELECTED_LOCALE = `${APPLICATION_NAME}_SELECTED_LOCALE`;
export const SESSION_STORAGE_SELECTED_LOCALE = `${APPLICATION_NAME}_SELECTED_LOCALE`;
export const LOCAL_STORAGE_CART_ITEMS = `${APPLICATION_NAME}_CART_ITEMS`;

export const googlePlacesKey = "AIzaSyCR388mWBleCqk4xOU2ZBjoBM_Aiu6VNt4";

export const SPLASH_SCREEN_DURATION_IN_MILLIS = 400;

export const keyboardTypeEnum = {
  default: "default",
  email: "email-address",
  numeric: "number-pad",
  decimal: "decimal-pad",
  phone: "phone-pad",
};

export const MAX_FILE_SIZE_IN_BYTES = 5000;

export const UPLOAD_ALLOWED_EXTENSIONS = ["png", "jpg", "jpeg"];
export const genders = [
  { text: "Male", value: "male" },
  { text: "Female", value: "female" },
  { text: "Occasion", value: "occasion" },
];

export const businessUserRoles = {
  owner: "owner",
  employee: "employee",
  superAdmin: "superAdmin",
  designer: "designer",
  productionAndLogistic: "productionAndLogistic",
  delivered: "delivered",
  production: "production",
  logistic: "logistic",
};

export const currencies = [
  { value: "sar", text: "SAR", symbol: "SR" },
  { value: "usd", text: "USD", symbol: "$" },
  { value: "eur", text: "EUR", symbol: "€" },
  { value: "kwd", text: "KWD", symbol: "ك" },
  { value: "bhd", text: "BHD", symbol: "BD" },
  { value: "aed", text: "AED", symbol: "د.إ" },
  { value: "qar", text: "QAR", symbol: "﷼" },
  { value: "omr", text: "OMR", symbol: "﷼" },
  { value: "egp", text: "EGP", symbol: "£" },
  { value: "jod", text: "JOD", symbol: "Dinar" },
  { value: "gbp", text: "GBP", symbol: "£" },
  { value: "cny", text: "CNY", symbol: "¥" },
  { value: "rub", text: "RUB", symbol: "₽" },
  { value: "aud", text: "AUD", symbol: "$" },
  { value: "inr", text: "INR", symbol: "₹" },
];

export const getCurrencySymbol = (currencyValue) => {
  switch (currencyValue) {
    case currencies[0].value:
      return currencies[0].symbol;
    case currencies[1].value:
      return currencies[1].symbol;
    case currencies[2].value:
      return currencies[2].symbol;
    case currencies[3].value:
      return currencies[3].symbol;
    case currencies[4].value:
      return currencies[4].symbol;
    case currencies[5].value:
      return currencies[5].symbol;
    case currencies[6].value:
      return currencies[6].symbol;
    case currencies[7].value:
      return currencies[7].symbol;
    case currencies[8].value:
      return currencies[8].symbol;
    case currencies[9].value:
      return currencies[9].symbol;
    case currencies[10].value:
      return currencies[10].symbol;
    case currencies[11].value:
      return currencies[11].symbol;
    case currencies[12].value:
      return currencies[12].symbol;
    case currencies[13].value:
      return currencies[13].symbol;
    case currencies[14].value:
      return currencies[14].symbol;
    default:
      return "N/A";
  }
};

export const codeSourceType = {
  phone: "phone",
  email: "email",
};

export const locales = [
  { text: "English", value: "en" },
  { text: "العربية", value: "ar" },
];

export const seeAllItemsCategory = {
  category: "category",
  section: "section",
};

export const sectionNames = {
  ads: {
    id: 1,
    name: "ADS",
    label: "explore-the-most-popular-gifts",
  },
  hot: {
    id: 2,
    name: "HOT",
    label: "hot-right-now",
  },
  new: {
    id: 3,
    name: "NEW",
    label: "new-on-ygii",
  },
  browseMore: {
    id: 4,
    name: "BROWSE_MORE",
    label: "browse-more",
  },
};

export const PROFILE_VISIBILITY = {
  PRIVATE: "private",
  FRIENDS: "friends",
  PUBLIC: "public",
};

export const GIFT_CARD_CATEGORY = {
  GRADUATION: "graduation",
  BIRTHDAY: "birthday",
  OTHER: "other",
};
export const DYNAMIC_ISLAND_PADDING = 15;

export const marketplaceOrderStates = [
  { id: 1, value: "created" },
  { id: 2, value: "wrapping" },
  { id: 3, value: "sent" },
  { id: 4, value: "received" },
];

export const orderStates = {
  created: "created",
  wrapping: "wrapping",
  sent: "sent",
  received: "received",
  initialized: "initialized",
  mockUp: "mockUp",
  production: "production",
  logistics: "logistics",
  delivered: "delivered",
};

export const marketplacePaymentStatus = [
  { id: 1, value: "pending" },
  { id: 2, value: "paid" },
  { id: 3, value: "paidFromWallet" },
  { id: 4, value: "declined" },
];

export const paymentStatus = {
  pending: "pending",
  paid: "paid",
  paidFromWallet: "paidFromWallet",
  declined: "declined",
};

export const billingPaymentStatus = [
  { id: 1, value: "pending" },
  { id: 2, value: "paid" },
  { id: 3, value: "declined" },
];

export const DEFAULT_LATITUDE = 24.774265;
export const DEFAULT_LONGITUDE = 46.738586;
export const MAP_ZOOM_LEVEL = 11;
export const MAP_LIBRARIES = ["places"];

export const giftingStatusObj = [
  { id: 1, value: "created" },
  { id: 2, value: "completed" },
  { id: 3, value: "paid" },
];

export const giftingStatus = {
  created: "created",
  completed: "completed",
  paid: "paid",
};

// exports.bookingStatus = {
//   active: "ACTIVE",
//   giftReceived: "GIFT_RECEIVED",
//   giftNotReceived: "GIFT_NOT_RECEIVED",
//   bookingCanceled: "BOOKING_CANCELED",
//   itemRemoved: "ITEM_REMOVED",
// };

// exports.ENV_TYPE = {
//   PRODUCTION: "production",
//   DEVELOPMENT: "development",
// };

// exports.GIFT_TYPES = {
//   ORDER: "order",
//   BOOKING: "booking",
// };

// exports.VIDEO = "video";
// exports.PHOTO = "photo";

export const departments = [
  { id: 1, value: "developer", label: "Developer" },
  { id: 2, value: "engineer", label: "Engineer" },
  { id: 3, value: "marketing", label: "Marketing" },
  { id: 4, value: "designer", label: "Designer" },
  { id: 5, value: "owner", label: "Owner" },
  { id: 6, value: "employee", label: "Employee" },
  { id: 7, value: "operations", label: "Operations" },
  { id: 8, value: "humanResources", label: "Human Resources" },
  { id: 9, value: "finance", label: "Finance" },
];

export const opsRoles = [
  "designer",
  "superAdmin",
  "productionAndLogistic",
  "production",
  "logistic",
  "delivered",
];

export const businessPortalRoles = ["superAdmin", "owner", "employee"];

export const packageName = {
  shippingBox: "Shipping Box",
  brandedBag: "Branded Bag",
  customBox: "Custom Box",
  brandedToteBag: "Branded Tote Bag",
};

export const allPackageNames = [
  packageName.shippingBox,
  packageName.brandedBag,
  packageName.customBox,
  packageName.brandedToteBag,
];

export const bannerPhotos = [
  { id: 1, url: Banner04, categoryName: "Ramadan" },
  { id: 2, url: Banner05, categoryName: "Saudi Founding Day" },
  { id: 3, url: Banner06, categoryName: "Winter Collection" },
];

export const PACKAGING_IMAGE_PROMPT = `Generate a minimal studio product photograph featuring the attached product displayed against a smooth matte background that transitions seamlessly from warm beige tone
 #c79c75 to #d0a77e through a subtle gradient. The scene is illuminated with soft, even lighting that creates gentle shadows beneath the product, emphasizing its shape and form without
  harsh highlights or reflections. The overall mood is calm, elegant, and natural, highlighting simplicity and sophistication. The background is free of textures and additional gradients,
   maintaining a clean, minimalist aesthetic with subtle lighting falloff to enhance depth. 
   The composition showcases the product along with its packaging, presented as it would be delivered to the final recipient, emphasizing a polished, high-quality presentation. 
   The style is contemporary and refined, suitable for modern product photography, with a focus on clarity, balance, and a professional, consistent look. 
   No text or branding is visible in the image. and add "Your design" wherever the product can be branded. Aspect ratio 1:1`;

export const REAL_LIFE_IMAGE_PROMPT = `Generate a high-resolution image of a product, isolated and clearly visible, accurately representing the item's features and details without any modifications or alterations. 
   The scene is set in a realistic, everyday environment that demonstrates how the product would be used in real life, such as a home, office, or outdoor setting relevant to the product's purpose. 
   The environment is detailed and natural, with appropriate props and background elements that complement the product, enhancing its usability context. 
   The lighting is bright and even to highlight the product's design and function clearly, with a focus on realism and authenticity. 
   The composition is clean and professional, ensuring the product remains the central focus while seamlessly integrating into the chosen environment to showcase its practical application effectively. 
   The style is photographic and true-to-life, suitable for e-commerce presentation, emphasizing clarity, detail, and realism to attract potential customers. Aspect ratio 1:1`;

export const BACKGROUND_PROMPT = `A minimal studio product photo with a smooth matte background in a warm beige tone (#c79c75 to #d0a77e gradient). 
The lighting is soft and even, with gentle shadows beneath the product. The overall atmosphere is calm and elegant, 
evoking a natural aesthetic. No visible textures, no gradients beyond subtle lighting falloff — clean, modern, 
and consistent product photography style with no writing anywhere in the photo. Aspect ratio 1:1
`;
export const businessUserRoleAction = {
  get_item: "get_item",
  post_item: "post_item",
  delete_item: "delete_item",
  put_item: "put_item",
  get_users: "get_users",
  post_users: "post_users",
  post_login_user: "post_login_user",
  get_company: "get_company",
  get_dashboard: "get_dashboard",
  post_category: "post_category",
  post_subcategory: "post_subcategory",
  get_category: "get_category",
  get_subcategory: "get_subcategory",
  delete_category: "delete_category",
  delete_subcategory: "delete_subcategory",
  post_generate_photos: "post_generate_photos",
  get_unit_type: "get_unit_type",
  post_item_priority: "post_item_priority",
  get_subscriptions: "get_subscriptions",
  get_subscriptions_all: "get_subscriptions_all",
  get_subscriptions_bank_transfers: "get_subscriptions_bank_transfers",
  post_subscriptions_review_bank_transfers:
    "post_subscriptions_review_bank_transfers",
  put_company_subscriptions: "put_company_subscriptions",
  post_subscriptions: "post_subscriptions",
  get_coupons: "get_coupons",
  get_coupons_all: "get_coupons_all",
  post_coupon: "post_coupon",
  put_coupon: "put_coupon",
  delete_coupon: "delete_coupon",
  get_coupon: "get_coupon",
  get_realtime_dashboard: "get_realtime_dashboard",
  get_business_role: "get_business_role",
  post_business_role: "post_business_role",
  put_business_role: "put_business_role",
  delete_business_role: "delete_business_role",
  post_add_business_role: "post_add_business_role",
  get_bank_transfers: "get_bank_transfers",
  post_bank_transfers: "post_bank_transfers",
  put_bank_transfers: "put_bank_transfers",
  get_marketplace_orders: "get_marketplace_orders",
  post_marketplace_orders: "post_marketplace_orders",
  put_marketplace_orders: "put_marketplace_orders",
  post_items_availability: "post_items_availability",
};

export const permissionCategories = [
  { key: "item", label: "products" },
  { key: "category", label: "products-categories" },
  { key: "subcategory", label: "products-subcategory" },
  { key: "item_priority", label: "products-priority" },
  { key: "business_role", label: "business-roles" },
  { key: "coupon", label: "coupon" },
  { key: "subscriptions", label: "subscriptions" },
  { key: "marketplace_orders", label: "orders" },
  { key: "bank_transfers", label: "wallet" },
  { key: "users", label: "users" },
  { key: "login_user", label: "login-to-user-account" },
  { key: "items_availability", label: "update-items-availability" },
];

export const permissionActions = [
  { key: "get", label: "view" },
  { key: "post", label: "create" },
  { key: "delete", label: "delete" },
];
